import { render, staticRenderFns } from "./reviews-badge.vue?vue&type=template&id=9472cfde&scoped=true&lang=pug&"
import script from "./reviews-badge.vue?vue&type=script&lang=coffee&"
export * from "./reviews-badge.vue?vue&type=script&lang=coffee&"
import style0 from "./reviews-badge.vue?vue&type=style&index=0&id=9472cfde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9472cfde",
  null
  
)

export default component.exports